import { render } from "./UploadInput.vue?vue&type=template&id=3c9626c2&scoped=true"
import script from "./UploadInput.vue?vue&type=script&lang=js"
export * from "./UploadInput.vue?vue&type=script&lang=js"

import "./UploadInput.vue?vue&type=style&index=0&id=3c9626c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9626c2"]])

export default __exports__